"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCrc = void 0;
var easyCrc_sidecar_1 = require("@dive/to-engine/easyCrc-sidecar");
var diveCrew_1 = require("./diveCrew");
var diveCrew_sidecar_1 = require("./diveCrew-sidecar");
function getCrc() {
    var e_1, _a;
    var _b, _c, _d;
    var _e = easyCrc_sidecar_1.easyCrc.create('crew'), add = _e.add, getCrc = _e.getCrc;
    try {
        // TODO: sort by id?
        for (var _f = __values(diveCrew_sidecar_1.diveCrew.getAll()), _g = _f.next(); !_g.done; _g = _f.next()) {
            var c = _g.value;
            if (c.isDead || c.isDying) {
                continue;
            }
            // Debugging filters
            if (c.type === diveCrew_1.EVoyageCrewType.Hero) {
                // continue
            }
            if (c.type === diveCrew_1.EVoyageCrewType.Pet) {
                // continue
            }
            if (c.type === diveCrew_1.EVoyageCrewType.Enemy) {
                // continue
            }
            add(c.id);
            add(c.name);
            // Same location
            add(c.i);
            add(c.j);
            // Health and stats
            add(c.hitpoints);
            // Weapon state
            if (c.weaponState) {
                add(c.weaponState.data.bulletType);
                add(c.weaponState.timer);
            }
            else {
                add(0); // no weapon
            }
            // Items
            add(((_b = c.weaponSlot) === null || _b === void 0 ? void 0 : _b.id) || 0);
            add(((_c = c.itemSlot1) === null || _c === void 0 ? void 0 : _c.id) || 0);
            add(((_d = c.lootSlot1) === null || _d === void 0 ? void 0 : _d.id) || 0);
            // Make sure our rando is sync'd
            // crc = crc16('|' + c.rando.getCurrentSeed(), crc)
            // if (c.animalState) {
            //   crc = crc16('|' + c.animalState.hasRolled, crc)
            // }
            add(c.rando.getNumRolls());
            add(c.rando.getCurrentSeed());
            // crc = crc16('|' + c.rando.getOriginalSeed(), crc)
            if (c.type === diveCrew_1.EVoyageCrewType.Pet) {
                // console.log(
                //   'crc numrolls',
                //   c.animalState?.hasRolled,
                //   c.rando.getNumRolls(),
                //   c.rando.getCurrentSeed(),
                //   c.rando.getOriginalSeed(),
                //   c.id,
                //   c.i,
                //   c.j,
                //   diveCrew.getAll().length,
                // )
            }
            // State
            // crc = crc32('|' + c.hitpoints, crc)
            add(c.isDownStairs);
            add(c.isUpStairs);
            add(c.isAwake);
            add(c.ticksAwake);
            add(c.stunLeft);
            add(c.name);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // console.log('getCrc', crc)
    return getCrc();
}
exports.getCrc = getCrc;
